'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
export default class UnsupportedField extends Component {
  renderTitleText() {
    const {
      idSchema
    } = this.props;

    if (!idSchema || !idSchema.$id) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.params.errors.unsupportedField.general"
      });
    }

    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-shared-components.params.errors.unsupportedField.withId",
      options: {
        id: idSchema.$id
      }
    });
  }

  render() {
    const {
      reason,
      type
    } = this.props;

    const body = /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: this.renderTitleText()
        })
      }), /*#__PURE__*/_jsx("br", {}), reason]
    });

    if (type === 'array') {
      return /*#__PURE__*/_jsx("div", {
        className: "params-row",
        children: body
      });
    }

    return body;
  }

}
UnsupportedField.propTypes = {
  idSchema: PropTypes.object,
  reason: PropTypes.node,
  type: PropTypes.string
};